// 通用模块多语言配置
export const common = {
  'zh-CN': {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    reset: '重置',
    loading: '加载中...',
    noData: '暂无数据',
    success: '操作成功',
    error: '操作失败',
    operationFailed: '操作失败',
    warning: '警告',
    info: '提示',
    completed: '已完成',
    incomplete: '未完成',
    exceeded: '超额完成',
    exceededIndex: '超额指数',
    yuan: '港元',
    serialNumber: '序号',
    unit: '单',
    remainingDays: '剩余天数',
    expired: '已过期',
    usedDays: '使用天数',
    // 错误消息
    pleaseEnterVerificationCode: '请输入验证码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseRepeatNewPassword: '请重复输入新密码',
    passwordsDoNotMatch: '两次输入内容不一样，请重新输入',
    smsCodeError: '短信验证码错误，请重新输入',
    emailCodeError: '邮箱验证码错误，请重新输入',
    modifySuccess: '修改成功',
    pleaseEnterOldPassword: '请输入旧密码',
    getCompanyInfoError: '获取企业信息异常',
    yes: '是',
    no: '否',
    saveSuccess: '保存成功',
    cancelled: '已取消',
    pleaseCompleteFormInfo: '请完善表单信息',
    close: '关闭',
    
    // 通用组件模块
    // 通用头部组件
    dashboard: '工作台',
    customer: '客户管理',
    businessManagement: '企业管理',
    order: '订单管理',
    merchandise: '商品管理',
    marketing: '营销活动',
    referral: '转介绍管理',
    finance: '财务管理',
    agent: '代理企业',
    video: '短视频管理',
    valueAdded: '增值服务',
    sharing: '分享推广管理',
    miniprogram: '前端设置',
    
    // 企业管理子菜单
    corporateInfo: '企业信息',
    enterpriseMember: '企业成员',
    performanceAssessment: '成员考核',
    advancedForm: '高级表单',
    advertising: '广告图管理',
    
    // 客户管理子菜单
    customerAdd: '客户录入',
    customerManagement: '客户管理',
    totalCustomer: '总客户池',
    
    // 商品管理子菜单
    merchandiseManagement: '商品管理',
    appointmentManagement: '预约管理',
    
    // 营销活动子菜单
    distribution: '分销',
    distributionStatistics: '分销统计',
    personnelApplication: '人员申请',
    distributionLevel: '分销等级',
    distributionOrder: '分销订单',
    accountTransfer: '到账流水',
    groupBuy: '拼团',
    productList: '拼团商品列表',
    participantsList: '参团列表',
    flashSale: '秒杀',
    flashSaleList: '秒杀商品列表',
    couponManagement: '优惠券管理',
    couponList: '优惠券列表',
    
    // 转介绍管理子菜单
    partnerList: '合作伙伴列表',
    rulesSetting: '规则设置',
    withdrawalList: '提现列表',
    
    // 财务管理子菜单
    financialStatistics: '财务统计',
    commissionManagement: '佣金管理',
    accountManagement: '账户管理',
    
    // 获客文章管理子菜单
    customerArticles: '获客文章',
    employeeData: '员工数据',
    visitorData: '访客数据',
    
    // 增值服务子菜单
    myNeeds: '我的需求',
    demandCheck: '需求审核',
    contactsCheck: '人脉集市审核',
    productsCheck: '产品中心审核',
    publishSetting: '发布设置',
    reportHandling: '举报处理',
    customizeSetting: '自定义设置',
    
    // 分享推广管理子菜单
    posterAtlas: '海报图集',
    clockData: '打卡数据',
    
    // 小程序设置子菜单
    appletConfig: '基础设置',
    basicSetting: '前端配置',
    mallSetting: '商城设置',
    
    // 通用操作
    logout: '退出登录',
    member: '成员',
    boss: 'boss',
    fullScreen: '全屏',
    cancelFullScreen: '取消全屏',
    oemConfigError: 'oem配置错误,请联系售后',
    ruizheCRM: '睿哲智能CRM',
    
    // 标签页组件
    pageOptions: '页面选项',
    closeOther: '关闭其他',
    closeAll: '关闭所有',
    
    // 成员列表组件
    noOtherMembers: '该部门暂无其他成员',
    selectAfterSales: '选择售后',
    
    // 文件上传组件
    downloadTemplateFirst: '请先下载导入模板的模板文件，按照文件内的内容编辑后再"选择文件上传"即可批量导入。',
    importTemplate: '导入模板：',
    clickToDownload: '点击下载',
    clickToUpload: '点击上传',
    importing: '导入中，请等待',
    importSuccess: '导入成功',
    importFailed: '导入失败'
  },
  'zh-TW': {
    confirm: '確認',
    cancel: '取消',
    save: '保存',
    delete: '刪除',
    edit: '編輯',
    add: '添加',
    search: '搜索',
    reset: '重置',
    loading: '載入中...',
    noData: '暫無數據',
    success: '操作成功',
    error: '操作失敗',
    operationFailed: '操作失敗',
    warning: '警告',
    info: '提示',
    completed: '已完成',
    incomplete: '未完成',
    exceeded: '超額完成',
    exceededIndex: '超額指數',
    yuan: '港元',
    serialNumber: '序號',
    unit: '單',
    remainingDays: '剩餘天數',
    expired: '已過期',
    usedDays: '使用天數',
    // 錯誤消息
    pleaseEnterVerificationCode: '請輸入驗證碼',
    pleaseEnterNewPassword: '請輸入新密碼',
    pleaseRepeatNewPassword: '請重複輸入新密碼',
    passwordsDoNotMatch: '兩次輸入內容不一樣，請重新輸入',
    smsCodeError: '短信驗證碼錯誤，請重新輸入',
    emailCodeError: '郵箱驗證碼錯誤，請重新輸入',
    modifySuccess: '修改成功',
    pleaseEnterOldPassword: '請輸入舊密碼',
    getCompanyInfoError: '獲取企業信息異常',
    yes: '是',
    no: '否',
    saveSuccess: '保存成功',
    cancelled: '已取消',
    pleaseCompleteFormInfo: '請完善表單信息',
    close: '關閉',
    
    // 通用组件模块
    // 通用头部组件
    dashboard: '工作台',
    customer: '客戶管理',
    businessManagement: '企業管理',
    order: '訂單管理',
    merchandise: '商品管理',
    marketing: '營銷活動',
    referral: '轉介紹管理',
    finance: '財務管理',
    agent: '代理企業',
    video: '短視頻管理',
    valueAdded: '增值服務',
    sharing: '分享推廣管理',
    miniprogram: '小程序設置',
    
    // 企业管理子菜单
    corporateInfo: '企業信息',
    enterpriseMember: '企業成員',
    performanceAssessment: '成員考核',
    advancedForm: '高級表單',
    advertising: '廣告圖管理',
    
    // 客户管理子菜单
    customerAdd: '客戶錄入',
    customerManagement: '客戶管理',
    totalCustomer: '總客戶池',
    
    // 商品管理子菜单
    merchandiseManagement: '商品管理',
    appointmentManagement: '預約管理',
    
    // 营销活动子菜单
    distribution: '分銷',
    distributionStatistics: '分銷統計',
    personnelApplication: '人員申請',
    distributionLevel: '分銷等級',
    distributionOrder: '分銷訂單',
    accountTransfer: '到賬流水',
    groupBuy: '拼團',
    productList: '拼團商品列表',
    participantsList: '參團列表',
    flashSale: '秒殺',
    flashSaleList: '秒殺商品列表',
    couponManagement: '優惠券管理',
    couponList: '優惠券列表',
    
    // 转介绍管理子菜单
    partnerList: '合作夥伴列表',
    rulesSetting: '規則設置',
    withdrawalList: '提現列表',
    
    // 财务管理子菜单
    financialStatistics: '財務統計',
    commissionManagement: '佣金管理',
    accountManagement: '賬戶管理',
    
    // 获客文章管理子菜单
    customerArticles: '獲客文章',
    employeeData: '員工數據',
    visitorData: '訪客數據',
    
    // 增值服务子菜单
    myNeeds: '我的需求',
    demandCheck: '需求審核',
    contactsCheck: '人脈集市審核',
    productsCheck: '產品中心審核',
    publishSetting: '發布設置',
    reportHandling: '舉報處理',
    customizeSetting: '自定義設置',
    
    // 分享推广管理子菜单
    posterAtlas: '海報圖集',
    clockData: '打卡數據',
    
    // 小程序设置子菜单
    appletConfig: '基礎設置',
    basicSetting: '前端配置',
    mallSetting: '商城設置',
    
    // 通用操作
    logout: '退出登錄',
    member: '成員',
    boss: 'boss',
    fullScreen: '全屏',
    cancelFullScreen: '取消全屏',
    oemConfigError: 'oem配置錯誤,請聯繫售後',
    ruizheCRM: '睿哲智能CRM',
    
    // 标签页组件
    pageOptions: '頁面選項',
    closeOther: '關閉其他',
    closeAll: '關閉所有',
    
    // 成员列表组件
    noOtherMembers: '該部門暫無其他成員',
    selectAfterSales: '選擇售後',
    
    // 文件上传组件
    downloadTemplateFirst: '請先下載導入模板的模板文件，按照文件內的內容編輯後再"選擇文件上傳"即可批量導入。',
    importTemplate: '導入模板：',
    clickToDownload: '點擊下載',
    clickToUpload: '點擊上傳',
    importing: '導入中，請等待',
    importSuccess: '導入成功',
    importFailed: '導入失敗'
  },
  'en': {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    operationFailed: 'Operation Failed',
    warning: 'Warning',
    info: 'Info',
    completed: 'Completed',
    incomplete: 'Incomplete',
    exceeded: 'Exceeded',
    exceededIndex: 'Exceeded Index',
    yuan: 'HK$',
    serialNumber: 'Serial Number',
    unit: 'Order',
    remainingDays: 'Remaining Days',
    expired: 'Expired',
    usedDays: 'Used Days',
    // Error messages
    pleaseEnterVerificationCode: 'Please enter verification code',
    pleaseEnterNewPassword: 'Please enter new password',
    pleaseRepeatNewPassword: 'Please repeat new password',
    passwordsDoNotMatch: 'Passwords do not match, please re-enter',
    smsCodeError: 'SMS verification code error, please re-enter',
    emailCodeError: 'Email verification code error, please re-enter',
    modifySuccess: 'Modified successfully',
    pleaseEnterOldPassword: 'Please enter old password',
    getCompanyInfoError: 'Failed to get company information',
    yes: 'Yes',
    no: 'No',
    saveSuccess: 'Save Success',
    cancelled: 'Cancelled',
    pleaseCompleteFormInfo: 'Please complete the form information',
    close: 'Close',
    
    // 通用组件模块
    // 通用头部组件
    dashboard: 'Dashboard',
    customer: 'Customer Management',
    businessManagement: 'Business Management',
    order: 'Order Management',
    merchandise: 'Merchandise Management',
    marketing: 'Marketing Activities',
    referral: 'Referral Management',
    finance: 'Financial Management',
    agent: 'Agent Enterprise',
    video: 'Video Management',
    valueAdded: 'Value Added Services',
    sharing: 'Sharing Promotion Management',
    miniprogram: 'Mini Program Settings',
    
    // 企业管理子菜单
    corporateInfo: 'Corporate Information',
    enterpriseMember: 'Enterprise Member',
    performanceAssessment: 'Performance Assessment',
    advancedForm: 'Advanced Form',
    advertising: 'Advertising Management',
    
    // 客户管理子菜单
    customerAdd: 'Customer Add',
    customerManagement: 'Customer Management',
    totalCustomer: 'Total Customer Pool',
    
    // 商品管理子菜单
    merchandiseManagement: 'Merchandise Management',
    appointmentManagement: 'Appointment Management',
    
    // 营销活动子菜单
    distribution: 'Distribution',
    distributionStatistics: 'Distribution Statistics',
    personnelApplication: 'Personnel Application',
    distributionLevel: 'Distribution Level',
    distributionOrder: 'Distribution Order',
    accountTransfer: 'Account Transfer',
    groupBuy: 'Group Buy',
    productList: 'Group Buy Product List',
    participantsList: 'Participants List',
    flashSale: 'Flash Sale',
    flashSaleList: 'Flash Sale List',
    couponManagement: 'Coupon Management',
    couponList: 'Coupon List',
    
    // 转介绍管理子菜单
    partnerList: 'Partner List',
    rulesSetting: 'Rules Setting',
    withdrawalList: 'Withdrawal List',
    
    // 财务管理子菜单
    financialStatistics: 'Financial Statistics',
    commissionManagement: 'Commission Management',
    accountManagement: 'Account Management',
    
    // 获客文章管理子菜单
    customerArticles: 'Customer Articles',
    employeeData: 'Employee Data',
    visitorData: 'Visitor Data',
    
    // 增值服务子菜单
    myNeeds: 'My Needs',
    demandCheck: 'Demand Check',
    contactsCheck: 'Contacts Check',
    productsCheck: 'Products Check',
    publishSetting: 'Publish Setting',
    reportHandling: 'Report Handling',
    customizeSetting: 'Customize Setting',
    
    // 分享推广管理子菜单
    posterAtlas: 'Poster Atlas',
    clockData: 'Clock Data',
    
    // 小程序设置子菜单
    appletConfig: 'Basic Settings',
    basicSetting: 'Frontend Configuration',
    mallSetting: 'Mall Settings',
    
    // 通用操作
    logout: 'Logout',
    member: 'Member',
    boss: 'Boss',
    fullScreen: 'Full Screen',
    cancelFullScreen: 'Cancel Full Screen',
    oemConfigError: 'OEM configuration error, please contact after-sales',
    ruizheCRM: 'Ruizhe Smart CRM',
    
    // 标签页组件
    pageOptions: 'Page Options',
    closeOther: 'Close Other',
    closeAll: 'Close All',
    
    // 成员列表组件
    noOtherMembers: 'No other members in this department',
    selectAfterSales: 'Select After Sales',
    
    // 文件上传组件
    downloadTemplateFirst: 'Please download the import template file first, edit according to the content in the file, then "Select File Upload" to batch import.',
    importTemplate: 'Import Template:',
    clickToDownload: 'Click to Download',
    clickToUpload: 'Click to Upload',
    importing: 'Importing, please wait',
    importSuccess: 'Import Success',
    importFailed: 'Import Failed'
  }
}; 